var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.045 6.5L12.68 11.135C13.1067 11.5617 13.1067 12.2534 12.68 12.68C12.2534 13.1067 11.5617 13.1067 11.135 12.68L6.5 8.045L1.86499 12.68C1.43834 13.1067 0.746622 13.1067 0.319981 12.68C-0.10666 12.2534 -0.10666 11.5617 0.319981 11.135L4.955 6.5L0.319981 1.86499C-0.10666 1.43834 -0.10666 0.746622 0.319981 0.319981C0.746622 -0.10666 1.43834 -0.10666 1.86499 0.319981L6.5 4.955L11.135 0.319981C11.5617 -0.10666 12.2534 -0.10666 12.68 0.319981C13.1067 0.746622 13.1067 1.43834 12.68 1.86499L8.045 6.5Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.70ac6e86.svg";
export { ForwardRef as ReactComponent };